const CategoryColumns = () => {
  return [
    {
      title: 'Category',
      dataIndex: 'name',
      editable: true,
    },
    {
      title: 'Data Level',
      dataIndex: 'level',
      editable: true,
    },
    {
      title: 'Crisis Level',
      dataIndex: 'crisis_level',
      editable: true,
    },
    {
      title: 'Comprehensive Level',
      dataIndex: 'report_level',
      align: 'center',
      editable: true,
    },
    {
      title: 'SPAM',
      dataIndex: 'spam',
      editable: true,
      align: 'right',
      width: 100,
      render: (text) => `${text} %`,
    },
    {
      title: 'Thời gian monitor',
      dataIndex: 'monitor_time',
      editable: true,
      align: 'right',
    },
    {
      title: 'Thời gian monitor theo level',
      dataIndex: 'monitor_by_level',
      editable: true,
      align: 'right',
    },
    {
      title: 'Tốc độ clarify dữ liệu',
      dataIndex: 'clarify_speed',
      editable: true,
      align: 'right',
    },
    {
      title: 'Effort',
      dataIndex: 'effort',
      editable: true,
      align: 'right',
      width: 100,
      render: (text) => `${text} %`,
    },
    {
      title: '% Saving',
      dataIndex: 'saving_percent',
      editable: true,
      align: 'right',
      width: 100,
      render: (text) => `${text} %`,
    },
  ];
};

export default CategoryColumns;
